var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmexLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 32,
    viewBox: "0 0 45 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 30.7647,
    rx: 3.5,
    fill: "#1F72CD",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06711 11.25L3.85681 20.8413H8.89712L9.52198 19.312H10.9502L11.5751 20.8413H17.1231V19.6741L17.6174 20.8413H20.4873L20.9816 19.6494V20.8413H32.5199L33.9229 19.3517L35.2366 20.8413L41.1629 20.8536L36.9393 16.0724L41.1629 11.25H35.3285L33.9628 12.712L32.6904 11.25H20.1383L19.0605 13.7256L17.9573 11.25H12.9275V12.3775L12.368 11.25H8.06711ZM9.04238 12.612H11.4993L14.292 19.1159V12.612H16.9834L19.1404 17.2752L21.1283 12.612H23.8063V19.4944H22.1768L22.1635 14.1014L19.7879 19.4944H18.3302L15.9413 14.1014V19.4944H12.5891L11.9536 17.9514H8.52011L7.88591 19.493H6.08983L9.04238 12.612ZM31.923 12.612H25.2971V19.4903H31.8204L33.9229 17.2107L35.9494 19.4903H38.0679L34.9888 16.0711L38.0679 12.612H36.0413L33.9495 14.8654L31.923 12.612ZM10.2376 13.7764L9.10637 16.5251H11.3674L10.2376 13.7764ZM26.9334 15.2933V14.037V14.0358H31.0677L32.8716 16.045L30.9877 18.0653H26.9334V16.6937H30.548V15.2933H26.9334Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexLg);
export default __webpack_public_path__ + "static/media/amexLg.3241cc6a.svg";
export { ForwardRef as ReactComponent };